import classes from "./brand_logo.module.css";
import LogoHorizontal from '@/assets/svg/logo-eh-horizontal.svg';
import LogoStacked from '@/assets/svg/logo-eh-stacked.svg';
import LogoMark from '@/assets/svg/logo-eh-mark.svg';

// SVGR strips the viewBox, so it is passed explicitly from the source dimensions
const LOGOS = {
    horizontal: { Svg: LogoHorizontal, width: 910.2, height: 117.4, defaultHeight: 32 },
    stacked: { Svg: LogoStacked, width: 669.6, height: 209.9, defaultHeight: 36 },
    mark: { Svg: LogoMark, width: 80, height: 88, defaultHeight: 40 },
};

// Size is set via width/height attributes (not CSS) so the logo never falls back to the SVG's natural size
export default function BrandLogo({ variant = "horizontal", height, className = "", ...props }) {
    const { Svg, width: vbWidth, height: vbHeight, defaultHeight } = LOGOS[variant] || LOGOS.horizontal;
    const h = height || defaultHeight;
    const w = Math.round(h * vbWidth / vbHeight);

    return <Svg className={`eh-logo ${classes.logo} ${className}`} width={w} height={h} viewBox={`0 0 ${vbWidth} ${vbHeight}`} {...props} />;
}

// One-line wordmark on desktop, two-line wordmark on the mobile header (menu | logo | profile)
export function ResponsiveBrandLogo({ className = "" }) {
    return <>
        <BrandLogo variant="horizontal" height={26} className={`${classes["responsive-horizontal"]} ${className}`} />
        <BrandLogo variant="stacked" height={34} className={`${classes["responsive-stacked"]} ${className}`} />
    </>;
}
